<slm-select-input
  label="INVOICE.DIVISION"
  [control]="control"
  [errors]="errors"
  [options]="userDivisionOptions$ | async"
  [clearButton]="clearButtonEnabled$ | async"
></slm-select-input>
